export class PublisherSpecific {

    public constructor(

    ) { }

    // The miracle function that tells whether element is visible??? whoaaa
    public isVisible(elem: Element) {
        const minOpacy = 0.1;
        try {
            if (!(elem instanceof Element)) throw Error('DomUtil: elem is not an element.');
            if (elem.className.indexOf('dx-accordion-item-closed')>=0) return false;
            const style = getComputedStyle(elem);
            if (style.display === 'none') return false;
            if (style.visibility !== 'visible') return false;
            if (style['aria-hidden']==='true') return false;
            if (parseFloat(style.opacity) < minOpacy) return false;
            if ((elem as HTMLElement).offsetWidth + (elem as HTMLElement).offsetHeight + elem.getBoundingClientRect().height +
            elem.getBoundingClientRect().width === 0) {
            return false;
            }
            // it's there, but outside the bounds (therefore removed): 
            // const elemCenter   = {
            //     x: elem.getBoundingClientRect().left + (elem as HTMLElement).offsetWidth / 2,
            //     y: elem.getBoundingClientRect().top + (elem as HTMLElement).offsetHeight / 2,
            // };
            //
            // if (elemCenter.x < 0) return false;
            // if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) return false;
            // if (elemCenter.y < 0) return false;
            // if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) return false;
            return true;
        } catch(ex) {
            // tslint:disable-next-line
            console.log(ex);
            return false;
        }
    }

    public isTab(node: HTMLElement) {
        // tslint:disable-next-line 
        return node["role"]=="tabpanel";
    }

    public tabHasReference(node: HTMLElement) {
        return node.getAttribute('aria-labelledby');
    }

    public isAccordion(node: HTMLElement) {
        return node&&node.className&&node.className.indexOf('dx-accordion-item-body')>=0;
    }
    
    public async unHideHidden(startNode: HTMLElement) {
        return new Promise((res, rej) => {
            var tophiddenElement: HTMLElement;
            try {
                var nodetrail = document.getElementById(startNode.id);
                if (nodetrail === undefined) {
                    return false;
                }
                while (nodetrail!=null) {         
                    if (nodetrail.parentNode!=null && !this.isVisible(nodetrail)) {
                        // The nasty part
                        if (this.isTab(nodetrail) && this.tabHasReference(nodetrail)) {
                            document.getElementById(nodetrail.getAttribute('aria-labelledby')).click();
                            tophiddenElement = nodetrail;
                        }
                        if (this.isAccordion(nodetrail)) {
                            if (nodetrail.parentElement!=null) {
                                nodetrail.parentElement.click();
                            }
                            tophiddenElement = nodetrail;
                        }
                    }
                    nodetrail = nodetrail.parentNode as HTMLElement;
                }
            } catch (ex) {
                // tslint:disable-next-line
                console.log(ex);
            }
            res(tophiddenElement);
        });
    }
    
    public async waitFor(selector: string) {
        // tslint:disable-next-line
        return new Promise((res, rej) => {
            const maxRetry = 4;
            const delay = 200;
            var retry: number = 1;
            waitForElementToDisplay(selector, delay);
            function waitForElementToDisplay(selector: string, time: number) {
                if (document.querySelector(selector) != null) {
                    res(document.querySelector(selector));
                } else {
                    retry++; // wait max 0.6 seconds no endless loops
                    if (retry > maxRetry) rej('Not found in DOM');
                    setTimeout(() => {
                        waitForElementToDisplay(selector, time);
                    }, time);
                }
            }
        });
    }    
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/publisherspecific/publisherspecific.tsx